import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";

/**
 * Guard component for private (authenticated) routes.
 * Usage: <Route path="..." element={<PrivateRoute><Page /></PrivateRoute>} />
 */
function PrivateRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isAuthenticated) {
    return children;
  } else if (auth.isLoading) {
    return <></>;
  } else {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
}

export default PrivateRoute;
